import { Component } from '@angular/core';
import {
  FieldType,
  FormlyField,
  FormlyValidationMessage,
} from '@ngx-formly/core';

@Component({
  selector: 'kon-object-type',
  template: `
    <div class="mb-3">
      @if (props.label) {
        <legend>{{ props.label }}</legend>
      }
      <!-- <p *ngIf="props.description">{{ props.description }}</p> -->
      @if (showError && formControl.errors) {
        <div class="alert alert-danger" role="alert">
          <formly-validation-message
            [field]="field"
          ></formly-validation-message>
        </div>
      }

      @for (field of field.fieldGroup; track field.key) {
        <formly-field [field]="field"></formly-field>
      }
    </div>
  `,
  standalone: true,
  imports: [FormlyValidationMessage, FormlyField],
})
export class ObjectTypeComponent extends FieldType {}
